import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { UserStoreModel, UserUIModel } from '@y42/user/models';
import { Observable } from 'rxjs';
import { InvitedUserStoreModel, OrgUserState } from '../models/org-user.model';
import { OrgUserStore } from './org-user.store';

@Injectable({ providedIn: 'root' })
export class OrgUserQuery extends QueryEntity<OrgUserState> {
  constructor(protected readonly orgUserStore: OrgUserStore) {
    super(orgUserStore);
  }

  readonly loading$ = this.selectLoading();
  readonly users$: Observable<UserStoreModel[]> = this.selectAll();
  readonly invitedUsers$: Observable<InvitedUserStoreModel[]> = this.select((state) => state.invited || []);

  areInvitedUsersLoaded(): boolean {
    return !!this.getValue().invited;
  }

  selectUIEntity(idOrEmail: UserStoreModel['id'] | string | undefined): Observable<UserUIModel | undefined> {
    return this.selectEntity((user) => {
      if (typeof idOrEmail === 'string') {
        return user.email === idOrEmail || user.id === Number(idOrEmail);
      }
      return user.id === idOrEmail;
    });
  }

  getUIEntity(idOrEmail: UserStoreModel['id'] | string | undefined): UserUIModel | undefined {
    if (idOrEmail === undefined) {
      return undefined;
    }

    if (typeof idOrEmail === 'number') {
      return this.getEntity(idOrEmail);
    } else {
      return this.getAll().find((entity) => entity.email === idOrEmail || entity.id === Number(idOrEmail));
    }
  }
}
